import React from 'react';

import cn from 'classnames';

import styles from './Card.module.css';

export const Card = ({
  className,
  children,
  ...cardProps
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) => (
  <article className={cn(styles.card, className)} {...cardProps}>
    {children}
  </article>
);
